import { useQuery } from "react-query";
import {
  deleteBonusQFileAppeal,
  getBonusQFileAppeal,
  postBonusQFileAppeal,
  putBonusQFileAppeal,
} from "~/pages/BonusQReport/requests/getBonusQFileAppeal";
import { useMutation, useQueryClient } from "react-query";

export function useGetBonusQFileAppeal() {
  return useQuery({
    queryKey: ["getBonusQFileAppeal"],
    queryFn: () => getBonusQFileAppeal(),
    enabled: true,
  });
}

export function usePostBonusQFileAppeal() {
  const queryClient = useQueryClient();
  return useMutation((fileId: number) => postBonusQFileAppeal(fileId), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getBonusQFileAppeal"]);
    },
  });
}

export function usePutBonusQFileAppeal() {
  const queryClient = useQueryClient();
  return useMutation((fileId: number) => putBonusQFileAppeal(fileId), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getBonusQFileAppeal"]);
    },
  });
}

export function useDeleteBonusQFileAppeal() {
  const queryClient = useQueryClient();
  return useMutation(() => deleteBonusQFileAppeal(), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getBonusQFileAppeal"]);
    },
  });
}
